import React from 'react';

const Presentation = () => (
  <div className="card flex-row w-75 align-items-center gap-5 p-3 mx-auto card-wrapper" style={{ minWidth: 'unset' }}>
    <iframe width="47%" height="300px" src="https://www.youtube.com/embedd/OCLadxqMB7U" title="Ruby On Rails || Blog App || Presentation || Fully Functional" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen />
    <iframe width="47%" height="300px" src="https://www.youtube.com/embedd/B6h-FqIgY6c" title="Ruby Backend Capstone Project Presentation || Full-Stack || Backend || Ruby || Programming || OOP" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen />
  </div>
);

export default Presentation;
